import { HTMLExtUtils } from '@ssml-editor/core';
import { BREAK_TYPE } from './constant.js';

const breakHtmlToElement = ({
  element,
  children
}) => {
  const mark = HTMLExtUtils.getDataAttribute(element, "mark", "");
  const time = HTMLExtUtils.getDataAttribute(element, "time", "");
  return {
    type: BREAK_TYPE,
    mark,
    time,
    children
  };
};

export { breakHtmlToElement };
//# sourceMappingURL=html-to-element.js.map
